import { NgModule } from '@angular/core';
import { RouterModule, Routes, Route } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouteNames } from './route-utils';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { LoggedInGuard, ClearCookiesGuard } from '@shared/guards';
import { LoginComponent } from '../login/login.component';
import { OverviewPageComponent } from '../overview-page/overview-page.component';
import { ResidentEnrollmentPortalComponent } from '../resident-enrollment-portal/resident-enrollment-portal.component';
import { RosterPageComponent } from '../roster-page/roster-page.component';
import { OitePageComponent } from '../oite-page/oite-page.component';
import { UnauthorizedComponent } from '../unauthorized/unauthorized.component';
import { AuthGuard } from '@shared/guards/auth.guard';
import { AdminPageComponent } from '../admin/admin-page.component';
import { OrderSummaryPageComponent } from '../order-summary-page/order-summary-page.component';
import { ResidentCurriculumPageComponent } from '../resident-curriculum/resident-curriculum-page/resident-curriculum-page.component';
import { FacultyPageComponent } from '../faculty-page/faculty-page.component';

const overview: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.overview,
  component : OverviewPageComponent
};

const admin: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.admin,
  component: AdminPageComponent
};

const roster: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.roster,
  component: RosterPageComponent
};

const oite: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.oite,
  component: OitePageComponent
};

const rock: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.rock,
  component: ResidentCurriculumPageComponent
};

const orderSummary: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.orderSummary,
  component: OrderSummaryPageComponent
};

const faculty: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.faculty,
  component: FacultyPageComponent
};

const pageNotFound: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.pageNotFound,
  component : PageNotFoundComponent
};

const main: Route = {
  canActivate: [LoggedInGuard, AuthGuard],
  path: RouteNames.root,
  redirectTo: RouteNames.Login,
  pathMatch: 'full'
};

const login: Route = {
  path: RouteNames.Login,
  component: LoginComponent
};

const unauthorized: Route = {
  path: RouteNames.unauthorized,
  component: UnauthorizedComponent
};



const portal: Route = {
  path: RouteNames.root,
  component: ResidentEnrollmentPortalComponent,
  children: [
    overview,
    roster,
    oite,
    rock,
    faculty,
    orderSummary,
    login,
    admin,
    main,
    pageNotFound,
    unauthorized
  ]
};

const routes: Routes = [portal];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
  ],
  providers: [LoggedInGuard, ClearCookiesGuard],
  exports: [RouterModule]
})
export class AppRoutingModule { }
